module.exports = __webpack_public_path__ + "img/block-left-small.26a17708.png";